// TODO: when committing to a quest, the submission answers coming from the
// survey form must be mapped to the quest's own answer schema before storage.
import {
  queryOptions,
  useQuery,
  type UseQueryResult,
} from '@tanstack/react-query'

import type { Survey } from '#survey/schemas/survey'

import parseQuestTemplates from '../parseQuestTemplates'
import abroadRaw from './abroad.yml?raw'
import bigPurchaseRaw from './bigPurchase.yml?raw'
import careerMoveRaw from './careerMove.yml?raw'
import carPurchaseRaw from './carPurchase.yml?raw'
import charitableGoalsRaw from './charitableGoals.yml?raw'
import collegeCostsRaw from './collegeCosts.yml?raw'
import homePurchaseRaw from './homePurchase.yml?raw'
import kidsRaw from './kids.yml?raw'
import loanRaw from './loan.yml?raw'
import marriageRaw from './marriage.yml?raw'
import nomadRaw from './nomad.yml?raw'
import savingsRaw from './savings.yml?raw'
import sideIncomeRaw from './sideIncome.yml?raw'
import spendLessRaw from './spendLess.yml?raw'
import startBusinessRaw from './startBusiness.yml?raw'

export const questTemplatesRaw: string[] = [
  sideIncomeRaw,
  homePurchaseRaw,
  carPurchaseRaw,
  charitableGoalsRaw,
  careerMoveRaw,
  abroadRaw,
  bigPurchaseRaw,
  collegeCostsRaw,
  kidsRaw,
  loanRaw,
  marriageRaw,
  nomadRaw,
  savingsRaw,
  spendLessRaw,
  startBusinessRaw,
]

const questTemplatesQueryOptions = queryOptions({
  queryKey: ['global', 'questTemplates'],
  queryFn: (): Promise<Survey> =>
    Promise.resolve(parseQuestTemplates(questTemplatesRaw)),
  staleTime: Infinity,
  gcTime: Infinity,
  retry: false,
})

export const useListQuestTemplatesQuery = (
  options: { enabled?: boolean } = {}
): UseQueryResult<Survey, Error> =>
  useQuery({
    ...questTemplatesQueryOptions,
    enabled: options.enabled ?? true,
  })
